import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-section-header',
  standalone: true,
  template: `
    <div class="section-header-accent-line">
      <h3 class="section-title-accent-line">{{ title }}</h3>
    </div>
  `,
})
export class SectionHeader {
  @Input({ required: true }) title = '';
}
